<div class="fa-icon-list-dialog">
    <app-frosty-dialog-shell
        eyebrow="Icons"
        title="Select Icon"
        [description]="iconsLoading ? 'Loading icon library...' : 'Search within ' + iconService.list.length + ' icons across thin, regular and solid styles.'"
        bodyClass="grid gap-4 px-1 pt-1">
        <button
            dialog-actions
            type="button"
            mat-icon-button
            class="shrink-0 rounded-md border border-white/60 bg-white/60"
            aria-label="Close icon picker"
            (click)="close()">
            <fa-icon [icon]="['fal','times']"></fa-icon>
        </button>

        <div class="grid gap-3 md:grid-cols-[minmax(0,1fr)_minmax(260px,340px)] md:items-end">
            <div class="min-w-0">
                <p class="m-0 text-xs font-semibold uppercase tracking-wide text-slate-500">
                    Icon library
                </p>
                <p class="m-0 mt-1 text-sm text-slate-600">
                    {{ iconsLoading ? 'Loading...' : (visibleIconCount + ' matching icons') }}
                </p>
            </div>

            <mat-form-field class="w-full frosty">
                <fa-icon matPrefix [icon]="['fal','search']" class="icon-size-5"></fa-icon>
                <input
                    matInput
                    placeholder="Search"
                    [ngModel]="searchTerm"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onSearchTermChange($event)"
                    autofocus />
            </mat-form-field>
        </div>

        <div *ngIf="iconsLoading"
            class="flex min-h-[18rem] items-center justify-center rounded-md border border-white/60 bg-white/45 p-6 text-sm font-semibold text-slate-500">
            Loading icon library...
        </div>

        <div *ngIf="!iconsLoading && iconLoadError"
            class="flex min-h-[18rem] items-center justify-center rounded-md border border-rose-200/70 bg-rose-50/60 p-6 text-sm font-semibold text-rose-700">
            Icon library could not be loaded.
        </div>

        <div *ngIf="!iconsLoading && !iconLoadError && !visibleIconCount"
            class="flex min-h-[18rem] items-center justify-center rounded-md border border-white/60 bg-white/45 p-6 text-sm font-semibold text-slate-500">
            No matching icon found.
        </div>

        <cdk-virtual-scroll-viewport
            *ngIf="!iconsLoading && !iconLoadError && visibleIconCount"
            itemSize="118"
            class="fa-icon-list-dialog__viewport rounded-md border border-white/60 bg-white/45 p-3">
            <div
                *cdkVirtualFor="let row of iconRows; trackBy: trackByIconRow"
                class="grid grid-cols-6 gap-2 pb-2">
                <button
                    *ngFor="let model of row; trackBy: trackByIcon"
                    type="button"
                    class="fa-icon-list-dialog__item rounded-md border border-white/70 bg-white/65 p-2 text-left transition hover:border-emerald-300 hover:bg-emerald-50/70"
                    [class.is-selected]="model.iconString === icon?.iconString"
                    (click)="select(model)">
                    <span class="block text-center text-xs font-semibold text-slate-500">
                        {{ model.prefix }}
                    </span>
                    <span class="my-2 flex h-10 items-center justify-center text-3xl text-slate-950">
                        <fa-icon [icon]="model.icon"></fa-icon>
                    </span>
                    <span class="block truncate text-center text-xs font-semibold text-slate-600">
                        {{ model.displayName }}
                    </span>
                </button>
            </div>
        </cdk-virtual-scroll-viewport>
    </app-frosty-dialog-shell>
</div>
